// extracted by mini-css-extract-plugin
export default {"muiAlert":"MUI-Alert_muiAlert__c5cdR"};